import { about1, about3, about5 } from "constants/Images";
import { useTranslation } from "react-i18next";

import "./about.css";

export default function About({ trans }) {
  const { i18n } = useTranslation();

  return (
    // <div id="AboutUs" className="container mt-5 pt-5 px-md-0 px-5  position-relative">
    <div
      id="AboutUs"
      className="container mt-5 pt-5 px-lg-4 px-md-0   px-5 position-relative  lg-padding"
    >
      <div className="d-flex justify-content-center w-100 mb-4">
        <h2>{trans("aboutUs", { ns: "navbar" })}</h2>
      </div>

      <div className=" position-relative ">
        <div className="  about-bg  rounded-4">
          <div className="h-100 w-100 position-absolute overlay rounded-4"></div>

          <div className="  row justify-content-end align-items-center h-100 position-relative p-5 md-3">
            <div className="col-lg-8 ps-md-4 px-0  padd">
              <div>
                <p className="fs-20 fs-md-18 fs-sm-16 fw-bold text-white text-shadow mb-5 text-center">
                  {/* At GSP Golden Star Paints, it's not just about paints and wood
                  stains—it's about excellence and innovation. Our expert team
                  of skilled chemists and top-tier sales professionals is
                  dedicated to delivering high-quality products and services
                  that clients can trust. Whether it’s residential or commercial
                  painting, wallpaper installation, or a complete makeover,
                  every project is handled with meticulous attention to detail
                  and completed on time. */}
                  {trans("AboutData.phara1", { ns: "navbar" })}
                </p>
                <p className="fs-20 fs-md-18 fs-sm-16 fw-bold text-white text-shadow text-center m-0 px-1">
                  {trans("AboutData.phara2", { ns: "navbar" })}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="img-float  ps-0 pe">
          {/* <div> */}
          <img src={about1} className=" rounded-4 w-100 h-100" />
          {/* </div> */}
        </div>

        <div className="img-1 px-0     align-content-end pe-md-2 pe-0 md-d-none">
          {/* <div className="d-lg-grid d-flex   h-fit-content bg-danger"> */}
          <div className=" d-flex justify-content-center align-items-center px-lg-0 pe-4  at-md">
            <p
              className={`${
                i18n.language == "ar" ? " fs-21" : "fs-20"
              } fw-bold text-black mb-4-1197  my-5 mb-4-1197 text-center`}
            >
              {/* Transform your space inside and out with the perfect coat of paint */}
              {trans("AboutData.phara3", { ns: "navbar" })}
            </p>
            {/* <p
              className={`${
                i18n.language == "ar" ? " fs-21" : "fs-20"
              } fw-bold text-black mb-4-1197  my-5 mb-4-1197 text-center`}
            >
              Transform your space inside and out with the perfect coat of paint
            </p> */}
          </div>
          {/* <div className=" w-100 h-100 bg-success"> */}
          <img src={about5} className=" rounded-4" />
          {/* </div> */}
          {/* </div> */}
        </div>

        <div className="img-2  pe-lg-0 ps-lg-5 pe-2 ps-0  md-d-none">
          {/* <div className="w-100 h-100 "> */}
          <img src={about3} className="w-100 h-100 rounded-4" />
          {/* </div> */}
        </div>
      </div>

      <div className="row md row-gap-4 lg-d-none">
        <div className="col-lg-4 px-0     align-content-end pe-2">
          {/* <div className="d-lg-grid d-flex   h-fit-content ">
            <div className=" d-flex justify-content-center align-items-center px-lg-0 pe-4">
              <p className="fs-20 fw-bold text-black mb-4-1197  mb-5 mb-4-1197 text-center">
                Transform your space inside and out with the perfect coat of
                paint
              </p>
            </div>
            <div className=" w-100">
              <img src={about5} className="w-100 h-100 rounded-4" />
            </div>
          </div> */}

          <div className=" d-flex px-0     align-content-end pe-md-2 pe-0 ">
            <div className=" d-flex justify-content-center align-items-center px-lg-0 pe-4  at-md">
              <p className="fs-20 fs-sm-16 fw-bold text-black mb-4-1197  my-5 mb-4-1197 text-center">
                Transform your space inside and out with the perfect coat of
                paint
              </p>
            </div>
            <img src={about5} className="img-md-1 rounded-4 " />
          </div>
        </div>
        <div className="col-lg-8  pe-lg-0 ps-lg-5 pe-2 ps-0">
          <div className="w-100 h-100 ">
            <img src={about3} className="w-100 h-100 rounded-4" />
          </div>
        </div>
      </div>
    </div>
  );
}
